/**
 * 通用工具方法
 */
import {DOMAIN_ADDRESS, LOGIN_URL, LOGOUT_URL} from '@/common/constant/variableConst';
import {env} from '@/common/services/envService';

// 当前站点域名
export function getDomainUrl() {
    return env.pick(DOMAIN_ADDRESS.online, DOMAIN_ADDRESS.sandbox);
}

// 登录地址（携带回跳）
export function getLoginUrl() {
    const url = env.pick(LOGIN_URL.online, LOGIN_URL.sandbox);
    const redirect = env.isClient ? location.href.replace(location.hash, '') + location.hash : getDomainUrl();
    return `${url}?redirect=${encodeURIComponent(redirect)}`;
}

// 登出地址（统一回跳首页）
export function getLogoutUrl() {
    const url = env.pick(LOGOUT_URL.online, LOGOUT_URL.sandbox);
    return `${url}?redirect=${encodeURIComponent(getDomainUrl())}`;
}

// 服务端日志着色
export function changeLogColor(input: string, color = 92) {
    return `\x1b[${color}m${input}\x1b[0m`;
}

// ---- Cookie / URL 工具（account v2 登录态同步用，仅浏览器端）----

// 读取 cookie，读不到返回空串
export function getCookie(name: string): string {
    if (env.isServer) {
        return '';
    }
    const matched = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
    return matched ? decodeURIComponent(matched[2]) : '';
}

/**
 * 写 cookie。days 传数字则按天设置过期，传 null/undefined 为会话级；
 * encode 为 true 时对 value 做 encodeURIComponent；domain 用于跨子域共享（如 .baidu.com）。
 */
export function setCookie(
    name: string,
    value: string,
    days?: number | null,
    encode = false,
    domain?: string,
    path = '/'
) {
    if (env.isServer) {
        return;
    }
    const val = encode ? encodeURIComponent(value) : value;
    let cookie = `${name}=${val}; path=${path}`;
    if (typeof days === 'number') {
        const expire = new Date();
        expire.setTime(expire.getTime() + days * 24 * 60 * 60 * 1000);
        cookie += `; expires=${expire.toUTCString()}`;
    }
    if (domain) {
        cookie += `; domain=${domain}`;
    }
    document.cookie = cookie;
}

// 删除 cookie（置为过期）
export function delCookie(name: string, domain?: string, path = '/') {
    if (env.isServer) {
        return;
    }
    let cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    if (domain) {
        cookie += `; domain=${domain}`;
    }
    document.cookie = cookie;
}

// 取当前 URL 上的全部 query 参数
export function getAllParamsFromUrl(): Record<string, string> {
    const params: Record<string, string> = {};
    if (env.isServer) {
        return params;
    }
    new URLSearchParams(location.search).forEach((value, key) => {
        params[key] = value;
    });
    return params;
}
